module.exports = __webpack_public_path__ + "img/_2.07d729ba.png";